module.exports = __webpack_public_path__ + "fonts/99d1709.woff";